<div class="entity-config-page land-court-page land-court-case-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-4 mx-auto px-4 py-4">
    <div class="land-court-sticky-header">
      <div class="d-flex flex-column gap-3 px-2">
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3">
          <button
            type="button"
            class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
            @click="go_back_to_caseload"
          >
            <i class="bi bi-arrow-left"></i>
            <span>Back to Case Load</span>
          </button>
          <div class="d-flex flex-column align-items-start align-items-lg-end gap-2">
            <span class="badge rounded-pill px-3 py-2 fw-semibold land-court-status-badge" :class="case_status_badge_class">
              {{ case_details.status_label }}
            </span>
            <div v-if="visible_case_transitions.length" class="d-flex flex-wrap justify-content-lg-end gap-2">
              <button
                v-for="transition in visible_case_transitions"
                :key="transition.id"
                type="button"
                class="btn land-court-submit-btn d-inline-flex align-items-center gap-2"
                :disabled="transitioning_to_status_id !== null"
                @click="move_case_to_next_status(transition)"
              >
                <i class="bi bi-arrow-right-circle"></i>
                <span>{{ transitioning_to_status_id === transition.targetId ? 'Moving...' : transition.action }}</span>
              </button>
            </div>
          </div>
        </div>

        <section class="land-court-hero-card rounded-4 px-4 py-3">
          <div class="d-flex align-items-start gap-3">
            <div>
              <div class="fw-bold land-court-group-title">{{ case_details.farm_title || 'Case details' }}</div>
              <div v-if="case_details.farm_location" class="small land-court-group-meta mt-1">{{ case_details.farm_location }}</div>
            </div>
          </div>
        </section>

        <section class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3 pb-4 border-bottom">
          <div>
            <p class="entity-page-title text-xs fw-bold land-court-case-title mb-2">{{ case_details.case_number }}</p>
            <p class="entity-page-subtitle text-dark fw-semibold fst-italic mb-0">{{ case_details.case_citation }}</p>
          </div>
          
        </section>
      </div>
    </div>

    <div v-if="loading_case_details">
      <div class="land-court-empty-state rounded-4 px-4 py-5 text-center">
        <div class="fw-semibold mb-1">Loading case details...</div>
        <div class="small text-secondary">Fetching live case data from the backend.</div>
      </div>
    </div>

    <div v-else-if="case_details_error">
      <div class="land-court-empty-state rounded-4 px-4 py-5 text-center">
        <div class="fw-semibold mb-1">Unable to load this case</div>
        <div class="small text-secondary">{{ case_details_error }}</div>
      </div>
    </div>

    <div v-else>
      <div
        v-if="show_schedule_hearing_modal"
        class="land-court-modal-backdrop"
        @click.self="close_schedule_hearing_modal"
      >
        <div class="land-court-modal-card rounded-4 shadow-lg">
          <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
            <div>
              <div class="h3 fw-bold mb-1 text-white">Schedule Hearing</div>
              <div class="small text-white">Choose the hearing date before moving this case into the hearing stage.</div>
            </div>
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent land-court-modal-close"
              :disabled="transitioning_to_status_id !== null"
              @click="close_schedule_hearing_modal"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="land-court-modal-body d-flex flex-column gap-3 p-3">
            <div>
              <label class="form-label land-court-filter-label">Hearing date</label>
              <input
                v-model="hearing_schedule_form.hearing_date"
                type="date"
                class="form-control land-court-modal-input rounded-4"
              >
            </div>

            <div>
              <label class="form-label land-court-filter-label">Notes</label>
              <textarea
                v-model.trim="hearing_schedule_form.notes"
                rows="3"
                class="form-control land-court-modal-input rounded-4"
                placeholder="Optional hearing notes"
              ></textarea>
            </div>

            <div class="land-court-modal-footer d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn land-court-submit-btn rounded px-3 py-2"
                :disabled="transitioning_to_status_id !== null"
                @click="close_schedule_hearing_modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                :disabled="transitioning_to_status_id !== null"
                @click="confirm_schedule_hearing"
              >
                <i class="bi bi-calendar-event"></i>
                <span>{{ transitioning_to_status_id !== null ? 'Scheduling...' : 'Schedule hearing' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="selected_document"
        class="land-court-modal-backdrop"
        @click.self="close_document_preview"
      >
        <div class="land-court-modal-card rounded-4 shadow-lg">
          <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
            <div>
              <div class="h3 fw-bold mb-1 text-white">Document Preview</div>
              <div class="small text-white">{{ selected_document.name || 'Previewing selected document' }}</div>
            </div>
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent land-court-modal-close"
              @click="close_document_preview"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="land-court-modal-body d-flex flex-column gap-3 p-3">
            <div class="small text-secondary">
              {{ selected_document.category || 'Document' }}
              <span v-if="selected_document.date"> - {{ selected_document.date }}</span>
            </div>

            <iframe
              v-if="selected_document.preview_url"
              :key="selected_document.preview_url"
              :src="selected_document.preview_url"
              title="Document preview"
              class="w-100 rounded-4 border"
              style="min-height: 70vh; background: #fff;"
            ></iframe>

            <div class="land-court-modal-footer d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn land-court-inline-action rounded px-3 py-2"
                @click="close_document_preview"
              >
                Close
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                @click="download_document(selected_document)"
              >
                <i class="bi bi-download"></i>
                <span>Download</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="show_edit_filing_modal"
        class="land-court-modal-backdrop"
        @click.self="cancel_add_filing"
      >
        <div class="land-court-modal-card rounded-4 shadow-lg">
          <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
            <div>
              <div class="h3 fw-bold mb-1 text-white">Edit Filing</div>
              <div class="small text-white">Update this pleading or notice.</div>
            </div>
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent land-court-modal-close"
              :disabled="saving_filing"
              @click="cancel_add_filing"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="land-court-modal-body d-flex flex-column gap-3 p-3">
            <div>
              <label class="form-label land-court-filter-label">Filing date</label>
              <input v-model="filing_form.filing_date" type="date" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Title</label>
              <input v-model.trim="filing_form.title" type="text" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Filing party</label>
              <select v-model="filing_form.actor" class="form-select land-court-modal-input rounded-4">
                <option v-for="option in filing_actor_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div>
              <label class="form-label land-court-filter-label">Description</label>
              <input v-model.trim="filing_form.description" type="text" class="form-control land-court-modal-input rounded-4">
            </div>
            <div class="land-court-modal-footer d-flex justify-content-end gap-2">
              <button type="button" class="btn land-court-inline-action rounded px-3 py-2" :disabled="saving_filing" @click="cancel_filing_edit">
                Cancel
              </button>
              <button type="button" class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2" :disabled="saving_filing" @click="save_filing_edit">
                <i class="bi bi-pencil-square"></i>
                <span>{{ saving_filing ? 'Updating...' : 'Update filing' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="show_edit_matter_modal"
        class="land-court-modal-backdrop"
        @click.self="cancel_add_matter"
      >
        <div class="land-court-modal-card rounded-4 shadow-lg">
          <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
            <div>
              <div class="h3 fw-bold mb-1 text-white">Edit Matter</div>
              <div class="small text-white">Update this interlocutory matter.</div>
            </div>
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent land-court-modal-close"
              :disabled="saving_matter"
              @click="cancel_add_matter"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="land-court-modal-body d-flex flex-column gap-3 p-3">
            <div>
              <label class="form-label land-court-filter-label">Matter date</label>
              <input v-model="matter_form.matter_date" type="date" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Title</label>
              <input v-model.trim="matter_form.title" type="text" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Status</label>
              <select v-model="matter_form.status" class="form-select land-court-modal-input rounded-4">
                <option v-for="option in matter_status_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div>
              <label class="form-label land-court-filter-label">Description</label>
              <input v-model.trim="matter_form.description" type="text" class="form-control land-court-modal-input rounded-4">
            </div>
            <div class="land-court-modal-footer d-flex justify-content-end gap-2">
              <button type="button" class="btn land-court-inline-action rounded px-3 py-2" :disabled="saving_matter" @click="cancel_matter_edit">
                Cancel
              </button>
              <button type="button" class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2" :disabled="saving_matter" @click="save_matter_edit">
                <i class="bi bi-pencil-square"></i>
                <span>{{ saving_matter ? 'Updating...' : 'Update matter' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="show_edit_note_modal"
        class="land-court-modal-backdrop"
        @click.self="cancel_note_edit"
      >
        <div class="land-court-modal-card rounded-4 shadow-lg">
          <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
            <div>
              <div class="h3 fw-bold mb-1 text-white">Edit Judge's Note</div>
              <div class="small text-white">Update this note.</div>
            </div>
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent land-court-modal-close"
              :disabled="saving_note"
              @click="cancel_note_edit"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="land-court-modal-body d-flex flex-column gap-3 p-3">
            <div>
              <label class="form-label land-court-filter-label">Note date</label>
              <input v-model="note_form.note_date" type="date" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Note</label>
              <textarea v-model.trim="note_form.body" rows="4" class="form-control land-court-modal-input rounded-4"></textarea>
            </div>
            <div class="land-court-modal-footer d-flex justify-content-end gap-2">
              <button type="button" class="btn land-court-inline-action rounded px-3 py-2" :disabled="saving_note" @click="cancel_note_edit">
                Cancel
              </button>
              <button type="button" class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2" :disabled="saving_note" @click="save_note_edit">
                <i class="bi bi-pencil-square"></i>
                <span>{{ saving_note ? 'Updating...' : 'Update note' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="show_edit_further_action_modal"
        class="land-court-modal-backdrop"
        @click.self="cancel_add_further_action"
      >
        <div class="land-court-modal-card rounded-4 shadow-lg">
          <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
            <div>
              <div class="h3 fw-bold mb-1 text-white">Edit Further Action</div>
              <div class="small text-white">Update this correspondence or action item.</div>
            </div>
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent land-court-modal-close"
              :disabled="saving_further_action"
              @click="cancel_add_further_action"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="land-court-modal-body d-flex flex-column gap-3 p-3">
            <div>
              <label class="form-label land-court-filter-label">Action date</label>
              <input v-model="further_action_form.action_date" type="date" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Title</label>
              <input v-model.trim="further_action_form.title" type="text" class="form-control land-court-modal-input rounded-4">
            </div>
            <div>
              <label class="form-label land-court-filter-label">Status</label>
              <select
                v-model="further_action_form.status"
                class="form-select land-court-modal-input rounded-4"
                @change="handle_further_action_status_change"
              >
                <option v-for="option in further_action_status_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div>
              <label class="form-label land-court-filter-label">Set reminder date and time</label>
              <input
                v-model="further_action_form.reminder_at"
                type="datetime-local"
                class="form-control land-court-modal-input rounded-4"
                aria-label="Set reminder date and time"
              >
            </div>
            <div>
              <label class="form-label land-court-filter-label">Correspondence</label>
              <textarea v-model.trim="further_action_form.correspondence" rows="4" class="form-control land-court-modal-input rounded-4"></textarea>
            </div>
            <div class="land-court-modal-footer d-flex justify-content-end gap-2">
              <button type="button" class="btn land-court-inline-action rounded px-3 py-2" :disabled="saving_further_action" @click="cancel_add_further_action">
                Cancel
              </button>
              <button type="button" class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2" :disabled="saving_further_action" @click="save_further_action">
                <i class="bi bi-pencil-square"></i>
                <span>{{ saving_further_action ? 'Updating...' : 'Update action' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="due_further_action_reminders.length"
        class="land-court-empty-state rounded-4 px-4 py-3 mx-2 text-start"
      >
        <div class="fw-semibold mb-1">Further action reminder</div>
        <div
          v-for="item in due_further_action_reminders"
          :key="item.id"
          class="small text-secondary"
        >
          {{ item.title }}<span v-if="item.reminder_label"> - {{ item.reminder_label }}</span>
        </div>
      </div>

      <section
        v-for="section in backend_case_sections"
        :key="section.backend_key"
        class="d-flex flex-column gap-3 px-2"
      >
        <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
          <p class="land-court-section-heading text-xl mb-0">{{ section.name }}</p>
          <div class="d-flex align-items-center gap-2">
            <template v-if="is_backend_farm_details_section(section) && editing_case_data">
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                :disabled="saving_case_data"
                @click="save_case_data"
              >
                <i class="bi bi-floppy"></i>
                <span>{{ saving_case_data ? 'Saving...' : 'Save' }}</span>
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_case_data"
                @click="cancel_case_data_edit"
              >
                Cancel
              </button>
            </template>
            <template v-else-if="is_editing_backend_section(section)">
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                :disabled="saving_backend_section_key === section.backend_key"
                @click="save_backend_section(section)"
              >
                <i class="bi bi-floppy"></i>
                <span>{{ saving_backend_section_key === section.backend_key ? 'Saving...' : 'Save' }}</span>
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_backend_section_key === section.backend_key"
                @click="cancel_backend_section_edit"
              >
                Cancel
              </button>
            </template>
            <template v-else-if="backend_section_layout(section) === 'party_cards'">
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                @click="open_add_parties_modal"
              >
                <i class="bi bi-plus-square"></i>
                <span>Add</span>
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                @click="open_parties_modal"
              >
                <i class="bi bi-pencil-square"></i>
                <span>Edit</span>
              </button>
            </template>
            <button
              v-else
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              @click="handle_backend_section_primary_action(section)"
            >
              <i class="bi" :class="backend_section_primary_action(section).icon"></i>
              <span>{{ backend_section_primary_action(section).label }}</span>
            </button>
          </div>
        </div>

        <div
          v-if="backend_section_layout(section) === 'party_cards'"
          class="row g-3"
        >
          <div class="col-12 col-xl-6">
            <div class="land-court-info-card bg-white rounded-4 h-100">
              <div class="land-court-info-block">
                <div class="land-court-info-label">Applicant 1</div>
                <div class="land-court-info-value">{{ case_details.parties.applicants || 'Not Provided' }}</div>
              </div>
              <div class="land-court-divider"></div>
              <div
                v-for="(representative, index) in representative_blocks(case_details.parties.applicants_legal_representatives)"
                :key="`backend-applicant-rep-${index}`"
                class="land-court-info-block"
              >
                <div class="land-court-info-label">Applicants' legal representative {{ index + 1 }}</div>
                <div
                  class="land-court-verification-badge mb-2"
                  :class="representative_verification_class(representative_verification_blocks(case_details.parties.applicants_legal_representatives_verified, representative_blocks(case_details.parties.applicants_legal_representatives).length)[index])"
                >
                  Representative details : {{ representative_verification_blocks(case_details.parties.applicants_legal_representatives_verified, representative_blocks(case_details.parties.applicants_legal_representatives).length)[index] }}
                </div>
                <div class="land-court-representative-detail-stack">
                  <div
                    v-for="detail in representative_detail_rows(representative)"
                    :key="`backend-applicant-rep-${index}-${detail.key}`"
                    class="land-court-representative-detail-row"
                  >
                    <span class="land-court-representative-detail-label">{{ detail.label }}</span>
                    <span class="land-court-representative-detail-value">{{ detail.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-6">
            <div class="land-court-info-card bg-white rounded-4 h-100">
              <div class="land-court-info-block">
                <div class="land-court-info-label">Respondent 1</div>
                <div class="land-court-info-value">{{ case_details.parties.respondents || 'Not Provided' }}</div>
              </div>
              <div class="land-court-divider"></div>
              <div
                v-for="(representative, index) in representative_blocks(case_details.parties.respondents_legal_representatives)"
                :key="`backend-respondent-rep-${index}`"
                class="land-court-info-block"
              >
                <div class="land-court-info-label">Landowner's legal representative {{ index + 1 }}</div>
                <div
                  class="land-court-verification-badge mb-2"
                  :class="representative_verification_class(representative_verification_blocks(case_details.parties.respondents_legal_representatives_verified, representative_blocks(case_details.parties.respondents_legal_representatives).length)[index])"
                >
                  Representative details : {{ representative_verification_blocks(case_details.parties.respondents_legal_representatives_verified, representative_blocks(case_details.parties.respondents_legal_representatives).length)[index] }}
                </div>
                <div class="land-court-representative-detail-stack">
                  <div
                    v-for="detail in representative_detail_rows(representative)"
                    :key="`backend-respondent-rep-${index}-${detail.key}`"
                    class="land-court-representative-detail-row"
                  >
                    <span class="land-court-representative-detail-label">{{ detail.label }}</span>
                    <span class="land-court-representative-detail-value">{{ detail.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else-if="backend_section_layout(section) === 'list'"
          class="land-court-list-card rounded-4 overflow-hidden"
        >
          <div
            v-if="is_backend_pleadings_section(section) && showing_add_filing && backend_filing_section_key === section.backend_key"
            class="land-court-inline-form-panel px-3 py-3 border-bottom"
          >
            <div class="row g-2 mb-2">
              <div class="col-12 col-lg-2">
                <input
                  v-model="filing_form.filing_date"
                  type="date"
                  class="form-control land-court-modal-input rounded-4"
                >
              </div>
              <div class="col-12 col-lg-7">
                <input
                  v-model.trim="filing_form.title"
                  type="text"
                  class="form-control land-court-modal-input rounded-4"
                  placeholder="e.g. Answering Affidavit, Notice of Bar, Rule 35 Notice"
                >
              </div>
              <div class="col-12 col-lg-3">
                <select v-model="filing_form.actor" class="form-select land-court-modal-input rounded-4">
                  <option v-for="option in filing_actor_options()" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <input
                v-model.trim="filing_form.description"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="Brief description (optional)"
              >
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn land-court-inline-action rounded-4 px-3 py-2"
                :disabled="saving_filing"
                @click="cancel_backend_filing"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                :disabled="saving_filing"
                @click="save_backend_filing(section)"
              >
                <i class="bi bi-floppy"></i>
                <span>{{ saving_filing ? 'Saving...' : 'Save' }}</span>
              </button>
            </div>
          </div>

          <div
            v-if="is_backend_interlocutory_section(section) && showing_add_matter && backend_matter_section_key === section.backend_key"
            class="land-court-inline-form-panel px-3 py-3 border-bottom"
          >
            <div class="row g-2 mb-2">
              <div class="col-12 col-lg-2">
                <input
                  v-model="matter_form.matter_date"
                  type="date"
                  class="form-control land-court-modal-input rounded-4"
                >
              </div>
              <div class="col-12 col-lg-7">
                <input
                  v-model.trim="matter_form.title"
                  type="text"
                  class="form-control land-court-modal-input rounded-4"
                  placeholder="e.g. Rule 35 discovery application"
                >
              </div>
              <div class="col-12 col-lg-3">
                <select v-model="matter_form.status" class="form-select land-court-modal-input rounded-4">
                  <option v-for="option in matter_status_options()" :key="option" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <input
                v-model.trim="matter_form.description"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="Brief description (optional)"
              >
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn land-court-inline-action rounded-4 px-3 py-2"
                :disabled="saving_matter"
                @click="cancel_backend_matter"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                :disabled="saving_matter"
                @click="save_backend_matter(section)"
              >
                <i class="bi bi-plus-square"></i>
                <span>{{ saving_matter ? 'Saving...' : 'Add matter' }}</span>
              </button>
            </div>
          </div>

          <div
            v-if="is_backend_judge_notes_section(section) && showing_add_note && backend_note_section_key === section.backend_key"
            class="land-court-inline-form-panel px-3 py-3 border-bottom"
          >
            <div class="row g-2 mb-2">
              <div class="col-12 col-lg-2">
                <input
                  v-model="note_form.note_date"
                  type="date"
                  class="form-control land-court-modal-input rounded-4"
                >
              </div>
              <div class="col-12 col-lg-10">
                <textarea
                  v-model.trim="note_form.body"
                  rows="2"
                  class="form-control land-court-modal-input rounded-4"
                  placeholder="Observations from the bench or chambers..."
                ></textarea>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_note"
                @click="cancel_backend_note"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
                :disabled="saving_note"
                @click="save_backend_note(section)"
              >
                <i class="bi bi-plus-square"></i>
                <span>{{ saving_note ? 'Saving...' : 'Save' }}</span>
              </button>
            </div>
          </div>

          <template v-if="backend_section_rows(section).length">
            <div
              v-for="row in backend_section_rows(section)"
              :key="`${section.backend_key}-${row.index}`"
              class="land-court-list-row"
            >
              <div class="land-court-list-date">{{ row.date || '' }}</div>
              <div class="land-court-list-content">
                <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
                  <span
                    v-if="row.badge"
                    class="badge rounded-pill px-3 py-1 fw-semibold land-court-status-badge"
                    :class="section_chip_class(row.badge_variant)"
                  >
                    {{ row.badge }}
                  </span>
                  <span class="land-court-list-title">{{ row.title }}</span>
                </div>
                <div v-if="row.subtitle" class="land-court-list-subtitle">{{ row.subtitle }}</div>
              </div>
              <div class="land-court-list-actions">
                <select
                  v-if="is_backend_interlocutory_section(section)"
                  :value="row.status || row.badge || 'Pending'"
                  class="land-court-matter-status-select p-1 rounded"
                  :disabled="saving_matter"
                  @change="update_backend_matter_status(section, row, $event.target.value)"
                >
                  <option v-for="option in matter_status_options()" :key="option" :value="option">{{ option }}</option>
                </select>
                <button
                  type="button"
                  class="btn p-0 border-0 bg-transparent"
                  @click="handle_backend_list_row_edit(section, row)"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>
              </div>
            </div>
          </template>
          <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
            <div class="fw-semibold mb-1">
              {{ is_backend_pleadings_section(section)
                ? 'No filings available'
                : is_backend_interlocutory_section(section)
                  ? 'No interlocutory matters available'
                  : 'No judge notes available' }}
            </div>
            <div class="small text-secondary">
              {{ is_backend_pleadings_section(section)
                ? 'No pleadings or notices have been saved for this case yet.'
                : is_backend_interlocutory_section(section)
                  ? 'No interlocutory matters have been saved for this case yet.'
                  : 'No judge notes have been saved for this case yet.' }}
            </div>
          </div>
        </div>

        <div
          v-else-if="is_backend_farm_details_section(section)"
          class="land-court-info-grid rounded-4 overflow-hidden px-2"
        >
          <template v-if="editing_case_data">
            <div
              v-for="field in editable_case_data_fields"
              :key="field.key"
              class="land-court-info-cell bg-white"
            >
              <div class="land-court-info-label">{{ case_data_field_label(field) }}</div>
              <select
                v-if="field.input_type === 'select'"
                v-model="case_data_form[field.key]"
                class="form-select land-court-modal-input rounded-4"
              >
                <option value="">{{ case_data_field_placeholder(field) }}</option>
                <option
                  v-for="option in case_data_field_options(field.key)"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
              <textarea
                v-else-if="field.input_type === 'textarea'"
                v-model.trim="case_data_form[field.key]"
                rows="4"
                class="form-control land-court-modal-input rounded-4"
                :placeholder="case_data_field_placeholder(field)"
              ></textarea>
              <input
                v-else
                v-model.trim="case_data_form[field.key]"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                :placeholder="case_data_field_placeholder(field)"
              >
            </div>
          </template>
          <template v-else-if="case_details.case_data.length">
            <div
              v-for="item in case_details.case_data"
              :key="item.label"
              class="land-court-info-cell bg-white"
            >
              <div class="land-court-info-label">{{ item.label }}</div>
              <div class="land-court-info-value" :class="item.tone">{{ item.value }}</div>
            </div>
          </template>
          <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
            <div class="fw-semibold mb-1">No farm details available</div>
            <div class="small text-secondary">
              Use the Add action above to enter the missing information for this section.
            </div>
          </div>
        </div>

        <div v-else-if="backend_section_has_answers(section) || is_editing_backend_section(section)" class="land-court-info-grid rounded-4 overflow-hidden px-2">
          <div
            v-for="question in section.questions"
            :key="backend_question_key(section, question)"
            class="land-court-info-cell bg-white"
          >
            <div class="land-court-info-label">{{ question.question_text }}</div>
            <div v-if="is_editing_backend_section(section)" class="mt-2">
              <select
                v-if="is_backend_select_question(question)"
                :value="backend_section_edit_value(question)"
                class="form-select land-court-modal-input rounded-4"
                @change="update_backend_section_edit_value(question, $event.target.value)"
              >
                <option value="">Select an option</option>
                <option
                  v-for="option in backend_question_choices(question)"
                  :key="option.id || option.choice || option"
                  :value="option.choice || option"
                >
                  {{ option.choice || option }}
                </option>
              </select>
              <textarea
                v-else-if="is_backend_long_text_question(question)"
                :value="backend_section_edit_value(question)"
                rows="4"
                class="form-control land-court-modal-input rounded-4"
                @input="update_backend_section_edit_value(question, $event.target.value)"
              ></textarea>
              <input
                v-else-if="is_backend_file_question(question)"
                type="file"
                class="form-control land-court-modal-input rounded-4"
                @change="update_backend_section_file_value(question, $event.target.files)"
              >
              <input
                v-else
                :value="backend_section_edit_value(question)"
                :type="backend_question_input_type(question)"
                class="form-control land-court-modal-input rounded-4"
                @input="update_backend_section_edit_value(question, $event.target.value)"
              >
            </div>
            <div v-else class="land-court-info-value text-dark" style="white-space: pre-wrap;">
              <a
                v-if="question.presigned_url"
                :href="question.presigned_url"
                target="_blank"
                rel="noopener"
                class="land-court-inline-link"
              >
                {{ backend_question_answer(question) }}
              </a>
              <span v-else>{{ backend_question_answer(question) }}</span>
            </div>
            <div v-if="question.question_description" class="small text-secondary mt-2">
              {{ question.question_description }}
            </div>
          </div>
        </div>
        <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
          <div class="fw-semibold mb-1">
            {{ section.name || 'Section' }} has no saved answers yet
          </div>
          <div class="small text-secondary">
            Use the Add action above to enter the missing information for this section.
          </div>
        </div>
      </section>

      <section v-if="false && has_case_data_section" class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3">
        <p class="land-court-section-heading text-xl mb-0">{{ case_data_section_heading }}</p>
        <div class="d-flex align-items-center gap-2">
          <button
            v-if="!editing_case_data"
            type="button"
            class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
            @click="begin_case_data_edit"
          >
            <i class="bi bi-pencil-square"></i>
            <span>Edit</span>
          </button>

          <template v-else>
            <button
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_case_data"
              @click="save_case_data"
            >
              <i class="bi bi-floppy"></i>
              <span>{{ saving_case_data ? 'Saving...' : 'Save' }}</span>
            </button>

            <button
              type="button"
              class="btn land-court-submit-btn rounded"
              :disabled="saving_case_data"
              @click="cancel_case_data_edit"
            >
              Cancel
            </button>
          </template>
        </div>
      </div>

      <div v-if="case_details.case_data.length && !editing_case_data" class="land-court-info-grid rounded-4 overflow-hidden px-2">
        <div
          v-for="item in case_details.case_data"
          :key="item.label"
          class="land-court-info-cell bg-white"
        >
          <div class="land-court-info-label">{{ item.label }}</div>
          <div class="land-court-info-value" :class="item.tone">{{ item.value }}</div>
        </div>
      </div>
      <div v-else-if="editing_case_data" class="land-court-info-grid rounded-4 overflow-hidden">
        <div
          v-for="field in editable_case_data_fields"
          :key="field.key"
          class="land-court-info-cell"
        >
          <div class="land-court-info-label">{{ case_data_field_label(field) }}</div>
          <select
            v-if="field.input_type === 'select'"
            v-model="case_data_form[field.key]"
            class="form-select land-court-modal-input rounded-4"
          >
            <option value="">{{ case_data_field_placeholder(field) }}</option>
            <option
              v-for="option in case_data_field_options(field.key)"
              :key="option"
              :value="option"
            >
              {{ option }}
            </option>
          </select>
          <textarea
            v-else-if="field.input_type === 'textarea'"
            v-model.trim="case_data_form[field.key]"
            rows="4"
            class="form-control land-court-modal-input rounded-4"
            :placeholder="case_data_field_placeholder(field)"
          ></textarea>
          <input
            v-else
            v-model.trim="case_data_form[field.key]"
            type="text"
            class="form-control land-court-modal-input rounded-4"
            :placeholder="case_data_field_placeholder(field)"
          >
        </div>
      </div>
      <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
        <div class="fw-semibold mb-1">No case data available</div>
        <div class="small text-secondary">The backend did not return populated answers for this case yet.</div>
      </div>
    </section>

    <section v-if="false && has_parties_section" class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
        <p class="land-court-section-heading text-xl mb-0">{{ parties_section_heading }}</p>
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
            @click="open_add_parties_modal"
          >
            <i class="bi bi-plus-square"></i>
            <span>Add</span>
          </button>
          <button
            type="button"
            class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
            @click="open_parties_modal"
          >
            <i class="bi bi-pencil-square"></i>
            <span>Edit</span>
          </button>
        </div>
      </div>

      <div v-if="case_details.parties.applicants || case_details.parties.respondents || case_details.parties.applicants_legal_representatives || case_details.parties.respondents_legal_representatives" class="row g-3">
        <div class="col-12 col-xl-6">
          <div class="land-court-info-card bg-white rounded-4 h-100">
            <template v-if="list_from_multiline(case_details.parties.applicants).length">
              <div
                v-for="(item, index) in list_from_multiline(case_details.parties.applicants)"
                :key="`applicant-${index}-${item}`"
              >
                <div class="land-court-info-block">
                  <div class="land-court-info-label">Applicant {{ index + 1 }}</div>
                  <div class="land-court-info-value">{{ item }}</div>
                </div>
                <div
                  v-if="index !== list_from_multiline(case_details.parties.applicants).length - 1 || list_from_multiline(case_details.parties.applicants_legal_representatives).length"
                  class="land-court-divider"
                ></div>
              </div>
            </template>
            <div v-else class="land-court-info-block">
              <div class="land-court-info-label">Applicants</div>
              <div class="land-court-info-value">Not provided</div>
            </div>
            <template v-if="representative_blocks(case_details.parties.applicants_legal_representatives).length">
              <div
                v-for="(item, index) in representative_blocks(case_details.parties.applicants_legal_representatives)"
                :key="`applicant-rep-${index}-${item}`"
              >
                <div class="land-court-info-block">
                  <div class="land-court-info-label">Applicants' legal representative {{ index + 1 }}</div>
                  <div
                    class="land-court-verification-badge mb-2"
                    :class="representative_verification_class(representative_verification_blocks(case_details.parties.applicants_legal_representatives_verified, representative_blocks(case_details.parties.applicants_legal_representatives).length)[index])"
                  >
                    Representative details : {{ representative_verification_blocks(case_details.parties.applicants_legal_representatives_verified, representative_blocks(case_details.parties.applicants_legal_representatives).length)[index] }}
                  </div>
                  <div class="land-court-representative-detail-stack">
                    <div
                      v-for="detail in representative_detail_rows(item)"
                      :key="`applicant-rep-${index}-${detail.key}`"
                      class="land-court-representative-detail-row"
                    >
                      <span class="land-court-representative-detail-label">{{ detail.label }}</span>
                      <span class="land-court-representative-detail-value">{{ detail.value }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="index !== representative_blocks(case_details.parties.applicants_legal_representatives).length - 1"
                  class="land-court-divider"
                ></div>
              </div>
            </template>
            <div v-else class="land-court-info-block">
              <div class="land-court-divider"></div>
              <div class="land-court-info-label mt-3">Applicants' legal representatives</div>
              <div class="land-court-info-value">Not provided</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-6">
          <div class="land-court-info-card rounded-4 h-100">
            <template v-if="list_from_multiline(case_details.parties.respondents).length">
              <div
                v-for="(item, index) in list_from_multiline(case_details.parties.respondents)"
                :key="`respondent-${index}-${item}`"
              >
                <div class="land-court-info-block">
                  <div class="land-court-info-label">Respondent {{ index + 1 }}</div>
                  <div class="land-court-info-value">{{ item }}</div>
                </div>
                <div
                  v-if="index !== list_from_multiline(case_details.parties.respondents).length - 1 || list_from_multiline(case_details.parties.respondents_legal_representatives).length"
                  class="land-court-divider"
                ></div>
              </div>
            </template>
            <div v-else class="land-court-info-block">
              <div class="land-court-info-label">Respondents</div>
              <div class="land-court-info-value">Not provided</div>
            </div>
            <template v-if="representative_blocks(case_details.parties.respondents_legal_representatives).length">
              <div
                v-for="(item, index) in representative_blocks(case_details.parties.respondents_legal_representatives)"
                :key="`respondent-rep-${index}-${item}`"
              >
                <div class="land-court-info-block">
                  <div class="land-court-info-label">Landowner's legal representative {{ index + 1 }}</div>
                  <div
                    class="land-court-verification-badge mb-2"
                    :class="representative_verification_class(representative_verification_blocks(case_details.parties.respondents_legal_representatives_verified, representative_blocks(case_details.parties.respondents_legal_representatives).length)[index])"
                  >
                    Representative details : {{ representative_verification_blocks(case_details.parties.respondents_legal_representatives_verified, representative_blocks(case_details.parties.respondents_legal_representatives).length)[index] }}
                  </div>
                  <div class="land-court-representative-detail-stack">
                    <div
                      v-for="detail in representative_detail_rows(item)"
                      :key="`respondent-rep-${index}-${detail.key}`"
                      class="land-court-representative-detail-row"
                    >
                      <span class="land-court-representative-detail-label">{{ detail.label }}</span>
                      <span class="land-court-representative-detail-value">{{ detail.value }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="index !== representative_blocks(case_details.parties.respondents_legal_representatives).length - 1"
                  class="land-court-divider"
                ></div>
              </div>
            </template>
            <div v-else class="land-court-info-block">
              <div class="land-court-divider"></div>
              <div class="land-court-info-label">Landowner's legal representatives</div>
              <div class="land-court-info-value">Not provided</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
        <div class="fw-semibold mb-1">No party data available</div>
        <div class="small text-secondary">This case does not yet have party answers available from the backend.</div>
      </div>
    </section>

    <div
      v-if="show_parties_modal"
      class="land-court-modal-backdrop"
      @click.self="close_parties_modal"
    >
      <div class="land-court-modal-card rounded-4 shadow-lg">
        <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
          <div>
            <div class="h3 fw-bold mb-1 text-white">Edit Parties &amp; Representation</div>
            <div class="small text-white">All parties and their legal representatives on record.</div>
          </div>
          <button
            type="button"
            class="btn p-0 border-0 bg-transparent land-court-modal-close"
            :disabled="saving_parties"
            @click="close_parties_modal"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="land-court-modal-body land-court-modal-scroll d-flex flex-column gap-3 p-3">
          <div>
            <label class="form-label land-court-filter-label">Applicants</label>
            <textarea
              v-model.trim="parties_form.applicants"
              rows="4"
              class="form-control land-court-modal-input rounded-4"
            ></textarea>
            <div class="small text-secondary mt-2">Use one line per applicant.</div>
          </div>

          <div>
            <label class="form-label land-court-filter-label">Applicants' legal representatives</label>
            <div class="d-flex flex-column gap-3">
              <div
                v-for="(representative, index) in parties_form.applicants_legal_representatives"
                :key="`edit-applicant-rep-${index}`"
                class="land-court-repeater-card rounded-4 p-3"
              >
                <div class="d-flex justify-content-between align-items-center gap-3 mb-2">
                  <div class="small fw-semibold text-secondary">Representative {{ index + 1 }}</div>
                  <button
                    v-if="parties_form.applicants_legal_representatives.length > 1"
                    type="button"
                    class="btn land-court-inline-action rounded px-3 py-2"
                    :disabled="saving_parties"
                    @click="remove_parties_form_block('applicants_legal_representatives', index)"
                  >
                    Remove
                  </button>
                </div>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Name</label>
                    <input
                      v-model.trim="parties_form.applicants_legal_representatives[index].firm_name"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Contact person</label>
                    <input
                      v-model.trim="parties_form.applicants_legal_representatives[index].contact_person"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12">
                    <label class="form-label land-court-filter-label">Address</label>
                    <textarea
                      v-model.trim="parties_form.applicants_legal_representatives[index].address"
                      rows="3"
                      class="form-control land-court-modal-input rounded-4"
                    ></textarea>
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Telephone number</label>
                    <input
                      v-model.trim="parties_form.applicants_legal_representatives[index].telephone_number"
                      type="tel"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                </div>
                <div class="mt-3">
                  <label class="form-label land-court-filter-label">Representative Details Verified</label>
                  <select
                    v-model="parties_form.applicants_legal_representatives_verified[index]"
                    class="form-select land-court-modal-input rounded-4"
                  >
                    <option
                      v-for="option in representative_verification_options()"
                      :key="`edit-applicant-rep-verified-${index}-${option}`"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-3 mt-2">
              <div class="small text-secondary">Each card is one representative. You can use multiple lines inside a card.</div>
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_parties"
                @click="add_parties_form_block('applicants_legal_representatives')"
              >
                Add representative
              </button>
            </div>
          </div>

          <div>
            <label class="form-label land-court-filter-label">Respondents</label>
            <textarea
              v-model.trim="parties_form.respondents"
              rows="4"
              class="form-control land-court-modal-input rounded-4"
            ></textarea>
            <div class="small text-secondary mt-2">Use one line per respondent.</div>
          </div>

          <div>
            <label class="form-label land-court-filter-label">Landowner's legal representatives</label>
            <div class="d-flex flex-column gap-3">
              <div
                v-for="(representative, index) in parties_form.respondents_legal_representatives"
                :key="`edit-respondent-rep-${index}`"
                class="land-court-repeater-card rounded-4 p-3"
              >
                <div class="d-flex justify-content-between align-items-center gap-3 mb-2">
                  <div class="small fw-semibold text-secondary">Representative {{ index + 1 }}</div>
                  <button
                    v-if="parties_form.respondents_legal_representatives.length > 1"
                    type="button"
                    class="btn land-court-inline-action rounded px-3 py-2"
                    :disabled="saving_parties"
                    @click="remove_parties_form_block('respondents_legal_representatives', index)"
                  >
                    Remove
                  </button>
                </div>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Name</label>
                    <input
                      v-model.trim="parties_form.respondents_legal_representatives[index].firm_name"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Contact person</label>
                    <input
                      v-model.trim="parties_form.respondents_legal_representatives[index].contact_person"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12">
                    <label class="form-label land-court-filter-label">Address</label>
                    <textarea
                      v-model.trim="parties_form.respondents_legal_representatives[index].address"
                      rows="3"
                      class="form-control land-court-modal-input rounded-4"
                    ></textarea>
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Telephone number</label>
                    <input
                      v-model.trim="parties_form.respondents_legal_representatives[index].telephone_number"
                      type="tel"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                </div>
                <div class="mt-3">
                  <label class="form-label land-court-filter-label">Representative Details Verified</label>
                  <select
                    v-model="parties_form.respondents_legal_representatives_verified[index]"
                    class="form-select land-court-modal-input rounded-4"
                  >
                    <option
                      v-for="option in representative_verification_options()"
                      :key="`edit-respondent-rep-verified-${index}-${option}`"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center gap-3 mt-2">
              <div class="small text-secondary">Each card is one representative. You can use multiple lines inside a card.</div>
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_parties"
                @click="add_parties_form_block('respondents_legal_representatives')"
              >
                Add representative
              </button>
            </div>
          </div>
          <div class="land-court-modal-footer d-flex justify-content-end gap-2">
          <button
            type="button"
            class="btn land-court-inline-action rounded px-3 py-2"
            :disabled="saving_parties"
            @click="close_parties_modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
            :disabled="saving_parties"
            @click="save_parties"
          >
            <i class="bi bi-floppy"></i>
            <span>{{ saving_parties ? 'Saving...' : 'Save' }}</span>
          </button>
        </div>
        </div>

        
      </div>
    </div>

    <div
      v-if="show_add_parties_modal"
      class="land-court-modal-backdrop"
      @click.self="close_add_parties_modal"
    >
      <div class="land-court-modal-card rounded-4 shadow-lg">
        <div class="land-court-modal-header d-flex justify-content-between align-items-start gap-3">
          <div>
            <div class="h3 fw-bold mb-1 text-white">Add Parties &amp; Representation</div>
            <div class="small text-white">Add new parties or representatives to the current record.</div>
          </div>
          <button
            type="button"
            class="btn p-0 border-0 bg-transparent land-court-modal-close"
            :disabled="saving_parties"
            @click="close_add_parties_modal"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="land-court-modal-body land-court-modal-scroll d-flex flex-column gap-3 p-3">
          <div>
            <label class="form-label land-court-filter-label">Applicants</label>
            <textarea
              v-model.trim="add_parties_form.applicants"
              rows="4"
              class="form-control land-court-modal-input rounded-4"
            ></textarea>
          </div>

          <div>
            <label class="form-label land-court-filter-label">Applicants' legal representatives</label>
            <div class="d-flex flex-column gap-3">
              <div
                v-for="(representative, index) in add_parties_form.applicants_legal_representatives"
                :key="`add-applicant-rep-${index}`"
                class="land-court-repeater-card rounded-4 p-3"
              >
                <div class="d-flex justify-content-between align-items-center gap-3 mb-2">
                  <div class="small fw-semibold text-secondary">Representative {{ index + 1 }}</div>
                  <button
                    v-if="add_parties_form.applicants_legal_representatives.length > 1"
                    type="button"
                    class="btn land-court-inline-action rounded px-3 py-2"
                    :disabled="saving_parties"
                    @click="remove_additional_parties_form_block('applicants_legal_representatives', index)"
                  >
                    Remove
                  </button>
                </div>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Name</label>
                    <input
                      v-model.trim="add_parties_form.applicants_legal_representatives[index].firm_name"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Contact person</label>
                    <input
                      v-model.trim="add_parties_form.applicants_legal_representatives[index].contact_person"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12">
                    <label class="form-label land-court-filter-label">Address</label>
                    <textarea
                      v-model.trim="add_parties_form.applicants_legal_representatives[index].address"
                      rows="3"
                      class="form-control land-court-modal-input rounded-4"
                    ></textarea>
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Telephone number</label>
                    <input
                      v-model.trim="add_parties_form.applicants_legal_representatives[index].telephone_number"
                      type="tel"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                </div>
                <div class="mt-3">
                  <label class="form-label land-court-filter-label">Representative Details Verified</label>
                  <select
                    v-model="add_parties_form.applicants_legal_representatives_verified[index]"
                    class="form-select land-court-modal-input rounded-4"
                  >
                    <option
                      v-for="option in representative_verification_options()"
                      :key="`add-applicant-rep-verified-${index}-${option}`"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_parties"
                @click="add_additional_parties_form_block('applicants_legal_representatives')"
              >
                Add representative
              </button>
            </div>
          </div>

          <div>
            <label class="form-label land-court-filter-label">Respondents</label>
            <textarea
              v-model.trim="add_parties_form.respondents"
              rows="4"
              class="form-control land-court-modal-input rounded-4"
            ></textarea>
          </div>

          <div>
            <label class="form-label land-court-filter-label">Landowner's legal representatives</label>
            <div class="d-flex flex-column gap-3">
              <div
                v-for="(representative, index) in add_parties_form.respondents_legal_representatives"
                :key="`add-respondent-rep-${index}`"
                class="land-court-repeater-card rounded-4 p-3"
              >
                <div class="d-flex justify-content-between align-items-center gap-3 mb-2">
                  <div class="small fw-semibold text-secondary">Representative {{ index + 1 }}</div>
                  <button
                    v-if="add_parties_form.respondents_legal_representatives.length > 1"
                    type="button"
                    class="btn land-court-inline-action rounded px-3 py-2"
                    :disabled="saving_parties"
                    @click="remove_additional_parties_form_block('respondents_legal_representatives', index)"
                  >
                    Remove
                  </button>
                </div>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Name</label>
                    <input
                      v-model.trim="add_parties_form.respondents_legal_representatives[index].firm_name"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Contact person</label>
                    <input
                      v-model.trim="add_parties_form.respondents_legal_representatives[index].contact_person"
                      type="text"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                  <div class="col-12">
                    <label class="form-label land-court-filter-label">Address</label>
                    <textarea
                      v-model.trim="add_parties_form.respondents_legal_representatives[index].address"
                      rows="3"
                      class="form-control land-court-modal-input rounded-4"
                    ></textarea>
                  </div>
                  <div class="col-12 col-md-6">
                    <label class="form-label land-court-filter-label">Telephone number</label>
                    <input
                      v-model.trim="add_parties_form.respondents_legal_representatives[index].telephone_number"
                      type="tel"
                      class="form-control land-court-modal-input rounded-4"
                    >
                  </div>
                </div>
                <div class="mt-3">
                  <label class="form-label land-court-filter-label">Representative Details Verified</label>
                  <select
                    v-model="add_parties_form.respondents_legal_representatives_verified[index]"
                    class="form-select land-court-modal-input rounded-4"
                  >
                    <option
                      v-for="option in representative_verification_options()"
                      :key="`add-respondent-rep-verified-${index}-${option}`"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button
                type="button"
                class="btn land-court-submit-btn rounded"
                :disabled="saving_parties"
                @click="add_additional_parties_form_block('respondents_legal_representatives')"
              >
                Add representative
              </button>
            </div>
          </div>
          <div class="land-court-modal-footer d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn land-court-inline-action rounded px-3 py-2"
              :disabled="saving_parties"
              @click="close_add_parties_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_parties"
              @click="save_added_parties"
            >
              <i class="bi bi-plus-square"></i>
              <span>{{ saving_parties ? 'Adding...' : 'Add' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <section v-if="false && has_pleadings_section" class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
        <p class="land-court-section-heading text-xl mb-0">{{ pleadings_section_heading }}</p>
        <button
          type="button"
          class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
          @click="open_add_filing"
        >
          <i class="bi bi-plus-square"></i>
          <span>Add filing</span>
        </button>
      </div>

      <div class="land-court-list-card rounded-4 overflow-hidden">
        <div v-if="showing_add_filing" class="land-court-inline-form-panel px-3 py-3 border-bottom">
          <div class="row g-2 mb-2">
            <div class="col-12 col-lg-2">
              <input
                v-model="filing_form.filing_date"
                type="date"
                class="form-control land-court-modal-input rounded-4"
              >
            </div>
            <div class="col-12 col-lg-7">
              <input
                v-model.trim="filing_form.title"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="e.g. Answering Affidavit, Notice of Bar, Rule 35 Notice"
              >
            </div>
            <div class="col-12 col-lg-3">
              <select v-model="filing_form.actor" class="form-select land-court-modal-input rounded-4">
                <option v-for="option in filing_actor_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </div>

          <div class="mb-3">
            <input
              v-model.trim="filing_form.description"
              type="text"
              class="form-control land-court-modal-input rounded-4"
              placeholder="Brief description (optional)"
            >
          </div>

          <div class="d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn land-court-submit-btn rounded"
              :disabled="saving_filing"
              @click="cancel_add_filing"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_filing"
              @click="save_filing"
            >
              <span>{{ saving_filing ? 'Saving...' : (editing_filing_id ? 'Update' : 'Save') }}</span>
            </button>
          </div>
        </div>

        <template v-if="case_details.pleadings.length">
          <div v-for="item in case_details.pleadings" :key="item.id" class="land-court-list-row">
            <div class="land-court-list-date">{{ item.date }}</div>
            <div class="land-court-list-content">
              <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
                <span class="badge rounded-pill px-3 py-1 fw-semibold land-court-status-badge" :class="section_chip_class(item.actor_variant)">
                  {{ item.actor }}
                </span>
                <span class="land-court-list-title">{{ item.title }}</span>
              </div>
              <div class="land-court-list-subtitle">{{ item.subtitle }}</div>
            </div>
            <div class="land-court-list-actions">
              <button
                type="button"
                class="btn p-0 border-0 bg-transparent"
                @click="edit_filing(item)"
              >
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>
        </template>
        <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
          <div class="fw-semibold mb-1">No filings available</div>
          <div class="small text-secondary">No pleadings or notices have been saved for this case yet.</div>
        </div>
      </div>
    </section>

    <section v-if="false && has_interlocutory_matters_section" class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
        <p class="land-court-section-heading text-xl mb-0">{{ interlocutory_matters_section_heading }}</p>
        <button
          type="button"
          class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
          @click="open_add_matter"
        >
          <i class="bi bi-plus-square"></i>
          <span>Add matter</span>
        </button>
      </div>

      <div class="land-court-list-card rounded-4 overflow-hidden">
        <div v-if="showing_add_matter" class="land-court-inline-form-panel px-3 py-3 border-bottom">
          <div class="row g-2 mb-2">
            <div class="col-12 col-lg-2">
              <input
                v-model="matter_form.matter_date"
                type="date"
                class="form-control land-court-modal-input rounded-4"
              >
            </div>
            <div class="col-12 col-lg-7">
              <input
                v-model.trim="matter_form.title"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="e.g. Rule 35 discovery application"
              >
            </div>
            <div class="col-12 col-lg-3">
              <select v-model="matter_form.status" class="form-select land-court-modal-input rounded-4">
                <option v-for="option in matter_status_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </div>

          <div class="mb-3">
            <input
              v-model.trim="matter_form.description"
              type="text"
              class="form-control land-court-modal-input rounded-4"
              placeholder="Brief description (optional)"
            >
          </div>

          <div class="d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn land-court-inline-action rounded-4 px-3 py-2"
              :disabled="saving_matter"
              @click="cancel_add_matter"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_matter"
              @click="save_matter"
            >
              <i class="bi" :class="editing_matter_id ? 'bi-pencil-square' : 'bi-plus-square'"></i>
              <span>{{ saving_matter ? 'Saving...' : (editing_matter_id ? 'Update matter' : 'Add matter') }}</span>
            </button>
          </div>
        </div>

        <template v-if="case_details.interlocutory_matters.length">
          <div v-for="item in case_details.interlocutory_matters" :key="item.id" class="land-court-list-row land-court-matter-row">
            <div class="land-court-list-date">{{ item.date }}</div>
            <div class="land-court-list-content">
              <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
                <span class="badge rounded-pill px-3 py-1 fw-semibold land-court-status-badge" :class="section_chip_class(item.status_variant)">
                  {{ item.status }}
                </span>
                <span class="land-court-list-title">{{ item.title }}</span>
              </div>
              <div class="land-court-list-subtitle">{{ item.subtitle }}</div>
            </div>
            <div class="land-court-list-actions">
              <select
                :value="item.status"
                class="land-court-matter-status-select p-1 rounded"
                :disabled="is_updating_matter_status(item)"
                @change="update_matter_status(item, $event.target.value)"
              >
                <option v-for="option in matter_status_options()" :key="option" :value="option">{{ option }}</option>
              </select>
              <button
                type="button"
                class="btn p-0 border-0 bg-transparent"
                :disabled="is_updating_matter_status(item)"
                @click="edit_matter(item)"
              >
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>
        </template>
        <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
          <div class="fw-semibold mb-1">No interlocutory matters available</div>
          <div class="small text-secondary">No interlocutory matters have been saved for this case yet.</div>
        </div>
      </div>
    </section>

    <section v-if="false && has_judges_notes_section" class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
        <p class="land-court-section-heading text-xl mb-0">{{ judges_notes_section_heading }}</p>
        <button
          type="button"
          class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
          @click="open_add_note"
        >
          <i class="bi bi-plus-square"></i>
          <span>Add note</span>
        </button>
      </div>

      <div class="land-court-list-card rounded-4 overflow-hidden">
        <div v-if="showing_add_note" class="land-court-inline-form-panel px-3 py-3 border-bottom">
          <div class="row g-2 mb-2">
            <div class="col-12 col-lg-2">
              <input
                v-model="note_form.note_date"
                type="date"
                class="form-control land-court-modal-input rounded-4"
              >
            </div>
            <div class="col-12 col-lg-10">
              <textarea
                v-model.trim="note_form.body"
                rows="2"
                class="form-control land-court-modal-input rounded-4"
                placeholder="Observations from the bench or chambers..."
              ></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn land-court-submit-btn rounded"
              :disabled="saving_note"
              @click="cancel_add_note"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_note"
              @click="save_note"
            >
              <i class="bi" :class="editing_note_id ? 'bi-pencil-square' : 'bi-plus-square'"></i>
              <span>{{ saving_note ? 'Saving...' : (editing_note_id ? 'Update' : 'Save') }}</span>
            </button>
          </div>
        </div>

        <template v-if="case_details.judges_notes.length">
        <div v-for="item in case_details.judges_notes" :key="item.id" class="land-court-note-row">
          <div class="land-court-list-date">{{ item.date }}</div>
          <div class="land-court-note-body">{{ item.body }}</div>
          <div class="land-court-list-actions">
            <button
              type="button"
              class="btn p-0 border-0 bg-transparent"
              @click="edit_note(item)"
            >
              <i class="bi bi-pencil-square"></i>
            </button>
          </div>
        </div>
        </template>
        <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
          <div class="fw-semibold mb-1">No judge notes available</div>
          <div class="small text-secondary">No judge notes have been saved for this case yet.</div>
        </div>
      </div>
    </section>

    <section class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
        <p class="land-court-section-heading text-xl mb-0">{{ documents_section_heading }}</p>
        <button
          type="button"
          class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
          @click="open_add_document"
        >
          <i class="bi bi-plus-square"></i>
          <span>Add document</span>
        </button>
      </div>

      <div class="land-court-list-card land-court-documents-card rounded-4 overflow-hidden">
        <div v-if="showing_add_document" class="land-court-inline-form-panel land-court-document-form-panel px-3 py-3 border-bottom">
          <button
            type="button"
            class="land-court-upload-dropzone w-100 text-start"
            @click="trigger_document_picker"
          >
            <input
              ref="document_file_input"
              type="file"
              class="d-none"
              accept=".pdf,.doc,.docx,.jpg,.jpeg"
              multiple
              @change="handle_document_file_change"
            >
            <div class="land-court-upload-icon">
              <i class="bi bi-upload"></i>
            </div>
            <div class="land-court-upload-copy">
              <div class="land-court-upload-title">
                {{ document_form.file_name || 'Choose a file to attach' }}
              </div>
              <div class="land-court-upload-subtitle">
                PDF, DOCX, JPG up to 50 MB
              </div>
            </div>
          </button>

          <div class="row g-2 mt-1 mb-2">
            <div class="col-12 col-lg-2">
              <input
                v-model="document_form.document_date"
                type="date"
                class="form-control land-court-modal-input rounded-4"
              >
            </div>
            <div class="col-12 col-lg-7">
              <select v-model="document_form.category" class="form-select land-court-modal-input rounded-4">
                <option v-for="option in document_category_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-12 col-lg-3">
              <select v-model="document_form.party" class="form-select land-court-modal-input rounded-4">
                <option v-for="option in document_party_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn land-court-submit-btn land-court-document-action-btn rounded"
              :disabled="saving_document"
              @click="cancel_add_document"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn land-court-submit-btn land-court-document-action-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_document"
              @click="save_document"
            >
              <i class="bi bi-plus-square"></i>
              <span>{{ saving_document ? 'Saving...' : 'Add to file' }}</span>
            </button>
          </div>
        </div>

        <template v-if="case_details.documents.length">
        <div v-for="item in case_details.documents" :key="item.id" class="land-court-document-row">
          <div class="d-flex align-items-center gap-3 min-w-0">
            <div class="land-court-doc-badge" :class="document_extension_class(item.extension_variant)">
              {{ item.extension || 'FILE' }}
            </div>
            <div class="min-w-0">
              <div class="land-court-list-title mb-1">{{ item.name }}</div>
              <div class="d-flex flex-wrap align-items-center gap-2 land-court-list-subtitle">
                <span class="badge rounded-pill px-3 py-1 fw-semibold land-court-status-badge" :class="section_chip_class(item.party_variant)">
                  {{ item.party }}
                </span>
                <span>{{ item.category }}<span v-if="item.size"> - {{ item.size }}</span></span>
              </div>
            </div>
          </div>
          <div class="land-court-doc-date">{{ item.date }}</div>
          <div class="land-court-doc-actions">
            <button type="button" class="btn p-0 border-0 bg-transparent" @click="view_document(item)">
              <i class="bi bi-eye"></i>
            </button>
            <button type="button" class="btn p-0 border-0 bg-transparent" @click="download_document(item)">
              <i class="bi bi-download"></i>
            </button>
            <button type="button" class="btn p-0 border-0 bg-transparent" @click="remove_document(item)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
        </template>
        <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
          <div class="fw-semibold mb-1">No documents available</div>
          <div class="small text-secondary">No uploaded documents were returned by the backend for this application.</div>
        </div>
      </div>
      </section>

     <section class="d-flex flex-column gap-3 px-2">
      <div class="d-flex justify-content-between align-items-center gap-3 mt-3">
        <p class="land-court-section-heading text-xl mb-0">{{ further_actions_section_heading }}</p>
        <button
          type="button"
          class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
          @click="open_add_further_action"
        >
          <i class="bi bi-plus-square"></i>
          <span>Add action</span>
        </button>
      </div>

      <div class="land-court-list-card rounded-4 overflow-hidden">
        <div v-if="showing_add_further_action" class="land-court-inline-form-panel px-3 py-3 border-bottom">
          <div class="row g-2 mb-2">
            <div class="col-12 col-lg-2">
              <label class="form-label land-court-filter-label">Action date</label>
              <input
                v-model="further_action_form.action_date"
                type="date"
                class="form-control land-court-modal-input rounded-4"
              >
            </div>
            <div class="col-12 col-lg-5">
              <label class="form-label land-court-filter-label">Title</label>
              <input
                v-model.trim="further_action_form.title"
                type="text"
                class="form-control land-court-modal-input rounded-4"
                placeholder="e.g. Follow up with applicants' attorneys"
              >
            </div>
            <div class="col-12 col-lg-2">
              <label class="form-label land-court-filter-label">Status</label>
              <select
                v-model="further_action_form.status"
                class="form-select land-court-modal-input rounded-4"
                @change="handle_further_action_status_change"
              >
                <option v-for="option in further_action_status_options()" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="col-12 col-lg-3">
              <label class="form-label land-court-filter-label">Set reminder date and time</label>
              <input
                v-model="further_action_form.reminder_at"
                type="datetime-local"
                class="form-control land-court-modal-input rounded-4"
                aria-label="Set reminder date and time"
              >
            </div>
          </div>

          <div class="mb-3">
            <textarea
              v-model.trim="further_action_form.correspondence"
              rows="2"
              class="form-control land-court-modal-input rounded-4"
              placeholder="Correspondence or action notes"
            ></textarea>
          </div>

          <div class="d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn land-court-inline-action rounded-4 px-3 py-2"
              :disabled="saving_further_action"
              @click="cancel_add_further_action"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn land-court-submit-btn rounded d-inline-flex align-items-center gap-2"
              :disabled="saving_further_action"
              @click="save_further_action"
            >
              <i class="bi" :class="editing_further_action_id ? 'bi-pencil-square' : 'bi-plus-square'"></i>
              <span>{{ saving_further_action ? 'Saving...' : (editing_further_action_id ? 'Update action' : 'Add action') }}</span>
            </button>
          </div>
        </div>

        <template v-if="case_details.further_actions.length">
          <div v-for="item in case_details.further_actions" :key="item.id" class="land-court-list-row land-court-matter-row">
            <div class="land-court-list-date">{{ item.date }}</div>
            <div class="land-court-list-content">
              <div class="d-flex align-items-center flex-wrap gap-2 mb-1">
                <span class="badge rounded-pill px-3 py-1 fw-semibold land-court-status-badge" :class="section_chip_class(item.status_variant)">
                  {{ item.status }}
                </span>
                <span v-if="item.reminder_due" class="badge rounded-pill px-3 py-1 fw-semibold land-court-status-badge land-court-status-warning">
                  Reminder due
                </span>
                <span class="land-court-list-title">{{ item.title }}</span>
              </div>
              <div class="land-court-list-subtitle">{{ item.correspondence }}</div>
              <div v-if="item.reminder_label" class="small text-dark fw-bold mt-1">Reminder : {{ item.reminder_label }}</div>
            </div>
            <div class="land-court-list-actions">
              <select
                :value="item.status"
                class="land-court-matter-status-select p-1 rounded"
                :disabled="is_updating_further_action_status(item)"
                @change="update_further_action_status(item, $event.target.value)"
              >
                <option v-for="option in further_action_status_options()" :key="option" :value="option">{{ option }}</option>
              </select>
              <button
                type="button"
                class="btn p-0 border-0 bg-transparent"
                :disabled="is_updating_further_action_status(item)"
                @click="edit_further_action(item)"
              >
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>
        </template>
        <div v-else class="land-court-empty-state rounded-4 px-4 py-5 text-center">
          <div class="fw-semibold mb-1">No further actions available</div>
          <div class="small text-secondary">No correspondence or further actions have been saved for this case yet.</div>
        </div>
      </div>
    </section>
    </div>
  </div>
</div>
